import { getContent as getLinkContent, PLUGIN_KEY as LINK_PLUGIN_KEY } from '../aks-insert-link-plugin';

export const getContent = (rawContent: string) => {
  return rawContent
    // Replace new line characters with HTML line breaks
    .replaceAll('\n', '<br>')

    // Replace markdown links with AKS links
    .replaceAll(/\[([^\]]+)\]\(([^)]+)\)/g, getLinkContent('$1', '$2', LINK_PLUGIN_KEY))

    // Replace markdown bold text with HTML strong tags
    .replaceAll(/\*\*([a-zA-Z0-9€£:!][^*]+[a-zA-Z0-9€£:!])\*\*/gm, '<strong>$1</strong>')
    
    // Replace markdown italic text with HTML em tags
    .replaceAll(/_([a-zA-Z0-9€£:!][^*]+[a-zA-Z0-9€£:!])_/gm, '<em>$1</em>');
};
